exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.nav-button[data-v-2763b1a8] {\n  width: 40px;\n}\n", ""]);

// exports
